<!--
 * @Author: lan.h
 * @Date: 2021-11-26 09:19:38
 * @LastEditors: lan.h
 * @LastEditTime: 2021-12-01 15:49:08
 * @Description: 
-->
<template>
  <div class="links" v-show="show">
    <div v-for="item,index in links" :key="index" v-show="item.name != declare && index < 5">
      <a v-if="item.name != '申报须知'" :href="item.link" >
        <p>{{ item.name | clipWords}}</p><i class="el-icon-right"></i>
      </a>
      <router-link v-else :to="{name:'declare'}"><p>申报须知</p><i class="el-icon-right"></i></router-link>
    </div>
  </div>
</template>
<script>
import { getVb100EnrollLink } from '@/service/main.js'
export default {
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      links: [],
      declare: ''
    }
  },
  computed: {
    route_name() {
      return this.$route.name
    }
  },
  watch: {
    route_name(val) {
      if(val == 'declare'){
        this.declare = '申报须知'
      }else{
        this.declare = ''
      }
    }
  },
  created () {
    this.getVb100EnrollLink()
  },
  filters: {
    clipWords(words) {
      return words.substr(0,4)
    }
  },
  methods: {
    async getVb100EnrollLink () {
      let res = await getVb100EnrollLink()
      if(res.status == 'success') {
        this.links = res.res
        if(this.$route.name == 'declare'){
          this.declare = '申报须知'
        }else{
          this.declare = ''
        }
      }
    },
    goToDeclare() {
      this.$router.push('declare')
    }
  }
}
</script>
<style lang="stylus" scoped>
.links
  position fixed
  bottom .4rem
  // height 100vh
  display flex
  flex-direction column
  justify-content flex-end
  right .4rem
  z-index 2001
  a
    width 1.2rem
    height 1.2rem
    border-radius 50%
    background linear-gradient(90deg, #D9BB9E, #C78E66)
    margin-top .3rem
    display flex
    justify-content center
    align-items center
    flex-direction column
    color #FFFFFF
    font-size .2rem
    font-family PingFang SC
    font-weight 500
    cursor pointer
    &:hover
      background linear-gradient(90deg,  #C78E66,#D9BB9E)
    p
      padding 0 .01rem
      line-height .32rem
      font-size .22rem
    i
      margin-top .06rem
</style>